import React from 'react';
import { srOnly } from '@domain-group/fe-brary';
import { StarFilledIcon } from '@domain-group/fe-co-icon';
import RmaLogo from '../../../shared/recommendations/rma-logo';
import RatingTooltip from './rating-tooltip';
import * as styles from './card-rating.style';

const RMA_LOGO_HEIGHT = 18;

export const MAX_RATING = 5;

export interface CardRatingProps {
  averageRating: number;
  totalReviews: number;
  inline?: boolean;
}

const CardRating = ({
  averageRating,
  totalReviews,
  inline = false,
}: CardRatingProps): JSX.Element => {
  const rating = Math.min(MAX_RATING, Math.max(averageRating, 0)).toFixed(1);

  return (
    <div css={styles.container(inline)} data-testid="card-rating">
      <span css={srOnly}>
        Rated {rating} out of {MAX_RATING} from {totalReviews}{' '}
        {totalReviews === 1 ? 'review' : 'reviews'} on RateMyAgent
      </span>
      <div css={styles.summary} aria-hidden="true">
        <StarFilledIcon
          size="custom"
          css={styles.star(inline)}
          data-testid="card-rating__star"
        />
        <span css={styles.average(inline)}>{rating}</span>
        <span css={styles.total}>({totalReviews})</span>
      </div>
      <div css={styles.attribution}>
        <span css={styles.attributionLogo(inline)} aria-hidden="true">
          <RmaLogo height={RMA_LOGO_HEIGHT} marginLeft={0} marginBottom={0} />
        </span>
        <RatingTooltip inline={inline} />
      </div>
    </div>
  );
};

export default CardRating;
